export default __webpack_public_path__ + "static/media/Blueberries_Berry-Gin-Tonic-Popsicles.0e83bb29.png";